import React from 'react';

import ExternalLink from './ExternalLink';

const ContactSupport = ({ children }) => (
  <ExternalLink
    className="underline"
    to="mailto:support@wallaroo.ai"
    color="red"
    size="md"
  >
    { children }
  </ExternalLink>
)

export default ContactSupport;
